import { render } from "./DownloadAppAlert.vue?vue&type=template&id=3895e98d&scoped=true&ts=true"
import script from "./DownloadAppAlert.vue?vue&type=script&lang=ts"
export * from "./DownloadAppAlert.vue?vue&type=script&lang=ts"

import "./DownloadAppAlert.vue?vue&type=style&index=0&id=3895e98d&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./DownloadAppAlert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3895e98d"]])

export default __exports__